'use client'

import { HOUSE_LIST_SHOW_MAP_KEY } from '@config'
import useProgressRouter from '@hooks/useProgressRouter'
import IconList from '@icon/house/list-view.svg'
import { useHouseListContext } from '@pageSearch/_modules/layout/context'
import { getFilterRouter } from '@pageSearch/_modules/search/filter/base'
import { searchResultDataLayer } from '@plugin/google/gtm/modules/houseList'
import { global } from '@store/index'
import { isEqual } from 'lodash-es'
import { useCallback } from 'react'
import { useBoolean, useLocalStorage } from 'react-use'
import { useRecoilValue } from 'recoil'
import useControl from '../useControl'

export default function ListViewControl() {
  return useControl(<ListViewControlContent />, { position: 'top-right', groupClass: false })
}
function ListViewControlContent() {
  const { mobile, isPad } = useRecoilValue(global)

  const {
    state,
    showMap
  } = useHouseListContext()
  const [visible, toggleVisible] = useBoolean(showMap)
  const { replaceRouter } = useProgressRouter()
  const [, setShowMapLocal] = useLocalStorage(HOUSE_LIST_SHOW_MAP_KEY, false)
  const changeHandle = useCallback(val => {
    searchResultDataLayer.toggleMap(val)
    toggleVisible()
    setShowMapLocal(val)
    const { slug } = state
    const [url, newSlug] = getFilterRouter(state)(houseRoute => {
      houseRoute.changeMapVisible(val)
    })

    if (!isEqual(slug, newSlug)) {
      replaceRouter(url)
    }
  }, [state, toggleVisible, replaceRouter, setShowMapLocal])

  if (!mobile && !isPad) {
    return null
  }

  return (
    <div
      className='h-40 rounded-sm cursor-pointer relative bg-white flex items-center shadow-md px-12 hover:bg-neutral-2'
      onClick={() => changeHandle(!visible)}
    >
      <IconList className='w-18 h-16 mr-6 fill-primary' />
      <span className='text-sm text-primary'>List view</span>
    </div>
  )
}
